// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pcsHqA3klFL30vb_Pn2p, .BBpBlYmAkohq2AYTquvR, .tr0g2AZ5pV4wweL9naUC, .xAAvvMKv62vnaWXr7NQ3 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.25rem;
}

.xAAvvMKv62vnaWXr7NQ3 {
  min-height: 260px;
}

.tr0g2AZ5pV4wweL9naUC {
  min-height: 10px;
  margin: 5px 0;
}

.BBpBlYmAkohq2AYTquvR {
  min-height: 45px;
}

.UmvpI_d2KCMb0OVWU7FQ {
  border: 1px solid black;
  border-style: dashed;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/modules/samples/components/layout-editor/components/droppable/droppable.module.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,qCAAA;EACA,YAAA;AAAF;;AAGA;EAEE,iBAAA;AADF;;AAIA;EAEE,gBAAA;EACA,aAAA;AAFF;;AAKA;EAEE,gBAAA;AAHF;;AAMA;EACE,uBAAA;EACA,oBAAA;AAHF","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n.row_common {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1.25rem;\n}\n\n.row {\n  @extend .row_common;\n  min-height: 260px;\n}\n\n.empty_row {\n  @extend .row_common;\n  min-height: 10px;\n  margin: 5px 0;\n}\n\n.empty_row_hover {\n  @extend .row_common;\n  min-height: 45px;\n}\n\n.drop_border {\n  border: 1px solid black;\n  border-style: dashed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row_common": `pcsHqA3klFL30vb_Pn2p`,
	"empty_row_hover": `BBpBlYmAkohq2AYTquvR`,
	"empty_row": `tr0g2AZ5pV4wweL9naUC`,
	"row": `xAAvvMKv62vnaWXr7NQ3`,
	"drop_border": `UmvpI_d2KCMb0OVWU7FQ`
};
export default ___CSS_LOADER_EXPORT___;
